import ZINC_ACTION_TYPES from './zinc.types';

export const ZINC_INITIAL_STATE = {
  zincList: [],
};

export const ZincReducer = (state = ZINC_INITIAL_STATE, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case ZINC_ACTION_TYPES.LOAD_ZINC: {
      return { ...state, zincList: payload };
    }
    default:
      return state;
  }
};
